import Vue from 'vue'
import formatRelative from 'date-fns/formatRelative'
import formatDistance from 'date-fns/formatDistance'
import format from 'date-fns/format'

Vue.filter('formatRelativeDate', (dateStr: string): string => {
  if (! dateStr) return ''
  return formatRelative(dateStr, Date.now())
})

Vue.filter('formatDistanceDate', (dateStr: string): string => {
  if (! dateStr) return ''
  return formatDistance(dateStr, Date.now())
})

Vue.filter('formatDateTime', (dateStr: string): string => {
  if (! dateStr) return ''
  return format(dateStr, 'dd/MM/yyyy HH:mm')
})
